export default __webpack_public_path__ + "e8a6a584aad621bfa8eda4791f81bb6a.png";